import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomModalComponent } from './custom-modal.component';


const routes: Routes = [{path:'',component:CustomModalComponent}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomModalRootingModule { }
